import ToastEventBus from 'primevue/toasteventbus'

export type TChatIncomingToastPayload = {
  peerUlid: string
  senderName: string
  body: string
  /** Vista previa cuando el mensaje es solo adjuntos (alineado con API). */
  list_preview?: string
  chat_ulid?: string
  type?: 'direct' | 'group'
}

/** Mismo canal que `useToast().add()`, usable desde Pinia sin `provide/inject`. */
export const showChatIncomingToast = (payload: TChatIncomingToastPayload) => {
  const bodyPreview =
    (payload.list_preview ?? '').trim() || payload.body.trim() || '—'

  ToastEventBus.emit('add', {
    severity: 'contrast' as const,
    group: 'chatIncoming',
    life: 5000,
    summary: payload.senderName,
    detail: bodyPreview,
    closable: false,
    peerUlid: payload.peerUlid,
    chat_ulid: payload.chat_ulid,
    type: payload.type,
    senderName: payload.senderName,
    bodyPreview,
  })
}
